import { useEffect } from "react";
import { useAuthStore } from "../../stores/useAuthStore";
import { useFirebaseStore } from "../../stores/useFirebaseStore";
import { MovieItem } from "../../components/movie-item";
import { LoginComp } from "../../components/common/LoginComp";
import { NoItemsFound } from "../../components/common/NoItemsFound";
import Loader from "../../components/common/Loader";
import "./index.css";

const FavoritesList = () => {
  const { profile } = useAuthStore();
  const isLoggedIn = Object.keys(profile).length > 0;
  const { fetchFavoriteMovies, favoriteMovies, isLoading } = useFirebaseStore();

  useEffect(() => {
    if (isLoggedIn) {
      fetchFavoriteMovies();
    }
  }, [fetchFavoriteMovies, isLoggedIn]);

  if (isLoading && favoriteMovies.length === 0) {
    return <Loader />;
  }

  if (favoriteMovies.length === 0) {
    return <NoItemsFound text="No movies in favorites!" />;
  }

  return (
    <div className="grid-container">
      {favoriteMovies.map((obj) => (
        <MovieItem key={obj.movieId} movie={obj.movie} />
      ))}
    </div>
  );
};

const FavoritesScreen = () => {
  const { profile } = useAuthStore();
  const isLoggedIn = Object.keys(profile).length > 0;

  return (
    <div className="screen-container">
      {isLoggedIn ? <FavoritesList /> : <LoginComp />}
    </div>
  );
};

export default FavoritesScreen;
